import { Check, ContentCopy } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

// TODO: MOVE COMPONENT TO CORE UI LIBRARY
const CopyButton = ({ textToCopy }) => {
    const { t: translate } = useTranslation();
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        if (copied) return;
        navigator.clipboard.writeText(textToCopy);
        setCopied(true);
        toast.info(translate('copied'), { position: 'top-right', theme: 'colored' });

        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <IconButton sx={{ color: '#131313bf' }} onClick={handleCopy}>
            {copied ? <Check /> : <ContentCopy />}
        </IconButton>
    );
};

export default CopyButton;
